import { BODY_SM_SM_MEDIUM_STYLES, BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const Description = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_STYLES};
`;

export const LearningRequirementsLink = styled.div`
    color: var(--colors-text-action, #2171c6);
    cursor: pointer;
    ${BODY_SM_SM_MEDIUM_STYLES};
`;
